import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2bdb39d1"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "logo-img" }, null, -1 /* HOISTED */))
const _hoisted_2 = ["textContent"]
const _hoisted_3 = { class: "navbar-version" }
const _hoisted_4 = ["textContent"]
const _hoisted_5 = { class: "navbar-dropdown-menu" }
const _hoisted_6 = ["textContent"]
const _hoisted_7 = { class: "navbar-dropdown-menu" }
const _hoisted_8 = ["textContent"]
const _hoisted_9 = ["textContent"]
const _hoisted_10 = ["textContent"]
const _hoisted_11 = ["textContent"]
const _hoisted_12 = ["textContent"]
const _hoisted_13 = ["textContent"]
const _hoisted_14 = ["textContent"]
const _hoisted_15 = ["textContent"]
const _hoisted_16 = ["textContent"]
const _hoisted_17 = { class: "navbar-dropdown-menu" }
const _hoisted_18 = ["textContent"]
const _hoisted_19 = ["textContent"]
const _hoisted_20 = ["textContent"]
const _hoisted_21 = ["textContent"]
const _hoisted_22 = ["textContent"]
const _hoisted_23 = ["textContent"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_navbar_brand = _resolveComponent("b-navbar-brand")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_b_navbar_toggle = _resolveComponent("b-navbar-toggle")!
  const _component_b_nav_item = _resolveComponent("b-nav-item")!
  const _component_entities_menu = _resolveComponent("entities-menu")!
  const _component_b_nav_item_dropdown = _resolveComponent("b-nav-item-dropdown")!
  const _component_b_dropdown_item = _resolveComponent("b-dropdown-item")!
  const _component_b_navbar_nav = _resolveComponent("b-navbar-nav")!
  const _component_b_collapse = _resolveComponent("b-collapse")!
  const _component_b_navbar = _resolveComponent("b-navbar")!

  return (_openBlock(), _createBlock(_component_b_navbar, {
    "data-cy": "navbar",
    toggleable: "md",
    type: "dark",
    class: "jh-navbar"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_b_navbar_brand, {
        class: "logo",
        "b-link": "",
        to: "/"
      }, {
        default: _withCtx(() => [
          _hoisted_1,
          _createElementVNode("span", {
            textContent: _toDisplayString(_ctx.t$('global.title')),
            class: "navbar-title"
          }, null, 8 /* PROPS */, _hoisted_2),
          _createTextVNode(),
          _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.version) + "-" + _toDisplayString(_ctx.gitHash), 1 /* TEXT */)
        ], undefined, true),
        _: 1 /* STABLE */
      }),
      _createVNode(_component_b_navbar_toggle, {
        right: "",
        class: "jh-navbar-toggler d-lg-none",
        href: "javascript:void(0);",
        "data-toggle": "collapse",
        target: "header-tabs",
        "aria-expanded": "false",
        "aria-label": "Toggle navigation"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_font_awesome_icon, { icon: "bars" })
        ], undefined, true),
        _: 1 /* STABLE */
      }),
      _createVNode(_component_b_collapse, {
        "is-nav": "",
        id: "header-tabs"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_b_navbar_nav, { class: "ml-auto" }, {
            default: _withCtx(() => [
              _createVNode(_component_b_nav_item, {
                to: "/",
                exact: ""
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", null, [
                    _createVNode(_component_font_awesome_icon, { icon: "home" }),
                    _createElementVNode("span", {
                      textContent: _toDisplayString(_ctx.t$('global.menu.home'))
                    }, null, 8 /* PROPS */, _hoisted_4)
                  ])
                ], undefined, true),
                _: 1 /* STABLE */
              }),
              (_ctx.authenticated)
                ? (_openBlock(), _createBlock(_component_b_nav_item_dropdown, {
                    key: 0,
                    right: "",
                    id: "entity-menu",
                    "active-class": "active",
                    class: "pointer",
                    "data-cy": "entity"
                  }, {
                    "button-content": _withCtx(() => [
                      _createElementVNode("span", _hoisted_5, [
                        _createVNode(_component_font_awesome_icon, { icon: "th-list" }),
                        _createElementVNode("span", {
                          class: "no-bold",
                          textContent: _toDisplayString(_ctx.t$('global.menu.entities.main'))
                        }, null, 8 /* PROPS */, _hoisted_6)
                      ])
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_entities_menu)
                    ], undefined, true),
                    _: 1 /* STABLE */
                  }))
                : _createCommentVNode("v-if", true),
              (_ctx.hasAnyAuthority('ROLE_ADMIN') && _ctx.authenticated)
                ? (_openBlock(), _createBlock(_component_b_nav_item_dropdown, {
                    key: 1,
                    right: "",
                    id: "admin-menu",
                    class: _normalizeClass([{ 'router-link-active': _ctx.subIsActive('/admin') }, "pointer"]),
                    "active-class": "active",
                    "data-cy": "adminMenu"
                  }, {
                    "button-content": _withCtx(() => [
                      _createElementVNode("span", _hoisted_7, [
                        _createVNode(_component_font_awesome_icon, { icon: "users-cog" }),
                        _createElementVNode("span", {
                          class: "no-bold",
                          textContent: _toDisplayString(_ctx.t$('global.menu.admin.main'))
                        }, null, 8 /* PROPS */, _hoisted_8)
                      ])
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_b_dropdown_item, {
                        to: "/admin/user-management",
                        "active-class": "active"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_font_awesome_icon, { icon: "users" }),
                          _createElementVNode("span", {
                            textContent: _toDisplayString(_ctx.t$('global.menu.admin.userManagement'))
                          }, null, 8 /* PROPS */, _hoisted_9)
                        ], undefined, true),
                        _: 1 /* STABLE */
                      }),
                      _createVNode(_component_b_dropdown_item, {
                        to: "/admin/metrics",
                        "active-class": "active"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_font_awesome_icon, { icon: "tachometer-alt" }),
                          _createElementVNode("span", {
                            textContent: _toDisplayString(_ctx.t$('global.menu.admin.metrics'))
                          }, null, 8 /* PROPS */, _hoisted_10)
                        ], undefined, true),
                        _: 1 /* STABLE */
                      }),
                      _createVNode(_component_b_dropdown_item, {
                        to: "/admin/health",
                        "active-class": "active"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_font_awesome_icon, { icon: "heart" }),
                          _createElementVNode("span", {
                            textContent: _toDisplayString(_ctx.t$('global.menu.admin.health'))
                          }, null, 8 /* PROPS */, _hoisted_11)
                        ], undefined, true),
                        _: 1 /* STABLE */
                      }),
                      _createVNode(_component_b_dropdown_item, {
                        to: "/admin/configuration",
                        "active-class": "active"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_font_awesome_icon, { icon: "cogs" }),
                          _createElementVNode("span", {
                            textContent: _toDisplayString(_ctx.t$('global.menu.admin.configuration'))
                          }, null, 8 /* PROPS */, _hoisted_12)
                        ], undefined, true),
                        _: 1 /* STABLE */
                      }),
                      _createVNode(_component_b_dropdown_item, {
                        to: "/admin/logs",
                        "active-class": "active"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_font_awesome_icon, { icon: "tasks" }),
                          _createElementVNode("span", {
                            textContent: _toDisplayString(_ctx.t$('global.menu.admin.logs'))
                          }, null, 8 /* PROPS */, _hoisted_13)
                        ], undefined, true),
                        _: 1 /* STABLE */
                      }),
                      (_ctx.openAPIEnabled)
                        ? (_openBlock(), _createBlock(_component_b_dropdown_item, {
                            key: 0,
                            to: "/admin/docs",
                            "active-class": "active"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_font_awesome_icon, { icon: "book" }),
                              _createElementVNode("span", {
                                textContent: _toDisplayString(_ctx.t$('global.menu.admin.apidocs'))
                              }, null, 8 /* PROPS */, _hoisted_14)
                            ], undefined, true),
                            _: 1 /* STABLE */
                          }))
                        : _createCommentVNode("v-if", true),
                      (!_ctx.inProduction)
                        ? (_openBlock(), _createBlock(_component_b_dropdown_item, {
                            key: 1,
                            href: "./h2-console/",
                            target: "_tab"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_font_awesome_icon, { icon: "database" }),
                              _createElementVNode("span", {
                                textContent: _toDisplayString(_ctx.t$('global.menu.admin.database'))
                              }, null, 8 /* PROPS */, _hoisted_15)
                            ], undefined, true),
                            _: 1 /* STABLE */
                          }))
                        : _createCommentVNode("v-if", true)
                    ], undefined, true),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["class"]))
                : _createCommentVNode("v-if", true),
              (_ctx.languages && Object.keys(_ctx.languages).length > 1)
                ? (_openBlock(), _createBlock(_component_b_nav_item_dropdown, {
                    key: 2,
                    id: "languagesnavBarDropdown",
                    right: ""
                  }, {
                    "button-content": _withCtx(() => [
                      _createVNode(_component_font_awesome_icon, { icon: "flag" }),
                      _createElementVNode("span", {
                        class: "no-bold",
                        textContent: _toDisplayString(_ctx.t$('global.menu.language'))
                      }, null, 8 /* PROPS */, _hoisted_16)
                    ]),
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.languages, (value, key) => {
                        return (_openBlock(), _createBlock(_component_b_dropdown_item, {
                          key: `lang-${key}`,
                          onClick: ($event: any) => (_ctx.changeLanguage(key)),
                          class: _normalizeClass({ active: _ctx.isActiveLanguage(key) })
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(value.name), 1 /* TEXT */)
                          ], undefined, true),
                          _: 2 /* DYNAMIC */
                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick", "class"]))
                      }), 128 /* KEYED_FRAGMENT */))
                    ], undefined, true),
                    _: 1 /* STABLE */
                  }))
                : _createCommentVNode("v-if", true),
              _createVNode(_component_b_nav_item_dropdown, {
                right: "",
                href: "javascript:void(0);",
                id: "account-menu",
                class: _normalizeClass([{ 'router-link-active': _ctx.subIsActive('/account') }, "pointer"]),
                "active-class": "active",
                "data-cy": "accountMenu"
              }, {
                "button-content": _withCtx(() => [
                  _createElementVNode("span", _hoisted_17, [
                    _createVNode(_component_font_awesome_icon, { icon: "user" }),
                    _createElementVNode("span", {
                      class: "no-bold",
                      textContent: _toDisplayString(_ctx.t$('global.menu.account.main'))
                    }, null, 8 /* PROPS */, _hoisted_18)
                  ])
                ]),
                default: _withCtx(() => [
                  (_ctx.authenticated)
                    ? (_openBlock(), _createBlock(_component_b_dropdown_item, {
                        key: 0,
                        "data-cy": "settings",
                        to: "/account/settings",
                        "active-class": "active"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_font_awesome_icon, { icon: "wrench" }),
                          _createElementVNode("span", {
                            textContent: _toDisplayString(_ctx.t$('global.menu.account.settings'))
                          }, null, 8 /* PROPS */, _hoisted_19)
                        ], undefined, true),
                        _: 1 /* STABLE */
                      }))
                    : _createCommentVNode("v-if", true),
                  (_ctx.authenticated)
                    ? (_openBlock(), _createBlock(_component_b_dropdown_item, {
                        key: 1,
                        "data-cy": "passwordItem",
                        to: "/account/password",
                        "active-class": "active"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_font_awesome_icon, { icon: "lock" }),
                          _createElementVNode("span", {
                            textContent: _toDisplayString(_ctx.t$('global.menu.account.password'))
                          }, null, 8 /* PROPS */, _hoisted_20)
                        ], undefined, true),
                        _: 1 /* STABLE */
                      }))
                    : _createCommentVNode("v-if", true),
                  (_ctx.authenticated)
                    ? (_openBlock(), _createBlock(_component_b_dropdown_item, {
                        key: 2,
                        "data-cy": "logout",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.logout())),
                        id: "logout",
                        "active-class": "active"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_font_awesome_icon, { icon: "sign-out-alt" }),
                          _createElementVNode("span", {
                            textContent: _toDisplayString(_ctx.t$('global.menu.account.logout'))
                          }, null, 8 /* PROPS */, _hoisted_21)
                        ], undefined, true),
                        _: 1 /* STABLE */
                      }))
                    : _createCommentVNode("v-if", true),
                  (!_ctx.authenticated)
                    ? (_openBlock(), _createBlock(_component_b_dropdown_item, {
                        key: 3,
                        "data-cy": "login",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openLogin())),
                        id: "login",
                        "active-class": "active"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_font_awesome_icon, { icon: "sign-in-alt" }),
                          _createElementVNode("span", {
                            textContent: _toDisplayString(_ctx.t$('global.menu.account.login'))
                          }, null, 8 /* PROPS */, _hoisted_22)
                        ], undefined, true),
                        _: 1 /* STABLE */
                      }))
                    : _createCommentVNode("v-if", true),
                  (!_ctx.authenticated)
                    ? (_openBlock(), _createBlock(_component_b_dropdown_item, {
                        key: 4,
                        "data-cy": "register",
                        to: "/register",
                        id: "register",
                        "active-class": "active"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_font_awesome_icon, { icon: "user-plus" }),
                          _createElementVNode("span", {
                            textContent: _toDisplayString(_ctx.t$('global.menu.account.register'))
                          }, null, 8 /* PROPS */, _hoisted_23)
                        ], undefined, true),
                        _: 1 /* STABLE */
                      }))
                    : _createCommentVNode("v-if", true)
                ], undefined, true),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["class"])
            ], undefined, true),
            _: 1 /* STABLE */
          })
        ], undefined, true),
        _: 1 /* STABLE */
      })
    ], undefined, true),
    _: 1 /* STABLE */
  }))
}